<template lang="pug">
dx-popup(
  ref="GestionUsuarioPopup"
  title="Gestión Usuario"
  width="1000"
  height="950px"
  position="top"
) 
  GestionUsuario(ref="GestionUsuarioPopupCmp" blank)
</template>

<script>
export default {
  created() {
    this.$root.$on("cerrarPopupAutomaticamente", () => {
      this.$refs.GestionUsuarioPopup.instance.hide();
    });
  },
  methods: {
    show(id) {
      this.$refs.GestionUsuarioPopup.instance.show();
      this.$refs.GestionUsuarioPopupCmp.init(id);

      this.$refs.GestionUsuarioPopup.instance.on("hidden", () => {
        this.$emit("popupClosed");
      });
    },
  },
};
</script>

<style>
/* 🔹 El popup no bloquea los scrolls internos */
::v-deep(.dx-popup-content) {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  background: #f9fafb;
  max-height: 95vh !important;
}

/* 🔒 Mantiene el tamaño del control GestionUsuario limitado */
.dx-overlay-content .dx-popup-content .erp-view-content {
  width: auto !important;
  max-width: 1000px !important;
  margin: 0 auto !important;
  height: auto !important;
  overflow-x: hidden !important;
  box-sizing: border-box !important;
}

/* Evita que el popup intente ocupar todo el ancho */
.dx-overlay-content {
  max-width: 1000px !important;
  max-height: 1000px !important;
  margin: 0 auto !important;
  overflow-x: hidden !important;
}

/* Contenedor principal con scroll general */
.scroll-container {
  padding: 12px;
  overflow-y: auto;
  max-height: 95vh;
  scroll-behavior: smooth;
  overscroll-behavior: contain; /* Evita que el scroll "salte" fuera del popup */
}

/* Scroll bonito */
.scroll-container::-webkit-scrollbar {
  width: 8px;
}
.scroll-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.scroll-container:hover::-webkit-scrollbar-thumb {
  background: #94a3b8;
}
</style>
